'use strict';

var mainMenuSelectors = document.querySelectorAll('.main--menu p');

var initMainMenuInteractions = function initMainMenuInteractions() {
  var mainWrapper = document.querySelector('.main-wrapper');

  if (!mainWrapper) {
    return;
  }
  mainMenuSelectors.forEach(function (selector) {
    selector.addEventListener('click', function () {
      mainWrapper.classList.toggle('active-menu');
    });
  });
};

mainMenuSelectors && initMainMenuInteractions();


//////////////////
// WEBPACK FOOTER
// ./js/menu/main-nav.js
// module id = ./js/menu/main-nav.js
// module chunks = 0